import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children, config }) => {
  const [isDark, setIsDark] = useState(config.defaultDarkMode);

  // Re-sync dark mode default when business changes (slug change)
  useEffect(() => {
    setIsDark(config.defaultDarkMode);
  }, [config.defaultDarkMode]);

  useEffect(() => {
    const { theme } = config;
    const root = document.documentElement;

    root.style.setProperty("--primary",      theme.primaryColor);
    root.style.setProperty("--secondary",    theme.secondaryColor);
    root.style.setProperty("--accent",       theme.accentColor);
    root.style.setProperty("--bg",           isDark ? theme.darkBackground  : theme.backgroundColor);
    root.style.setProperty("--text",         isDark ? theme.darkText        : theme.textColor);
    root.style.setProperty("--card-bg",      isDark ? "#1e293b"             : "#ffffff");
    root.style.setProperty("--border-color", isDark ? "#334155"             : "#e2e8f0");
    root.style.setProperty("--radius",       theme.borderRadius);
    root.style.setProperty("--font",         theme.fontFamily);

    document.body.classList.toggle("dark-mode", isDark);
  }, [isDark, config]);

  const toggleDark = () => setIsDark((p) => !p);

  return (
    <ThemeContext.Provider value={{ isDark, toggleDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
